import * as React from 'react';
import Modal from "react-responsive-modal";
import {SetStateAction, useEffect, useState} from "react";
import Icons from "./../../Icons";
import {getBoutiqueColor, getShopRefInStorage} from "./../../MonCompteAction";
import Embrodery from "./Embrodery";
import {BtnActionApplyOutline} from "./BtnAction.applyOutline";
import {BtnActionReupload} from "./BtnAction.Reupload";
import {BtnActionOperateurCorrection} from "./BtnAction.OperatorCorrection";
import {BtnActionValidationBat} from "./BtnAction.validationBAT";
import {CheckboxActionNonConforme} from "./CheckboxAction.nonConforme";
import {bgLikeTextile, emulateCouleurTextile} from "../UploadUtils";
import {NonConforme} from "./NonConforme";
import {SwitchActionConformity} from "./SwitchAction.conformity";
import {BtnActionEmbroidery} from "./BtnAction.embroidery";
import {getShopInfosInStorage} from "../../../cart/ShopInfos";
import {ThumbnailsControl} from "./ThumbnailsControl";
import {ZoomImg} from "./ZoomImg";

interface ModalFileVerificationProps {
  data: any,
  authorizedFiles: string[],
  handleChangeRowValidationVisuelChecked: any,
  handleChangeNonConformeChecked?: (keyVisuel: string, state: boolean) => void,
  handleChangeApplyOutline: any,
  fusionMultiply: boolean,
  bgColor: string,
  statutVisuel: number
  nonConforme: boolean,
  handleChangeConformity: any,
  reuploadBtnAdminBatValide: boolean,
  getPreview: (idCaddies: string, forceUpdate: boolean, onlyPreview: boolean) => void,
  surfaceId: number,
  emplacementId: number;
  surfaceEmplacementId: number;
  onReupload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const _defineFinesse = (props: ModalFileVerificationProps) => {
  let firstCheck = typeof props.data.finesse !== 'undefined' && props.data.finesse !== '' && props.data.displayFinesse;
  if(firstCheck && props.data.dataConformity  && props.data.dataConformity.etatConformity !== null && props.data.isInternalUser  && !props.data.customerView) {
    firstCheck = false;
  }
  
  if(firstCheck && props.data.dataConformity.etatConformity !== null && props.data.customerView) {
    firstCheck = false;
  }

  return firstCheck;
}

export const ModalFileVerification = (props: ModalFileVerificationProps) => {
  const isBatAutoBroderieNotInternal = props.data.isBatAutoBroderie && props.data.marquage.id == 4 && (!props.data.isInternalUser || props.data.customerView);
  const isBatAutoBroderieCustomerCanChoiceBroderie = props.data.isBatAutoBroderie && props.data.marquage.id == 4 && props.data.customerChoixBroderie;
  const [key, setKey] = useState(props.data.keyVisuel);
  const [statut, setStatut] = useState(props.statutVisuel);
  const [nonConforme, setNonConforme] = useState<boolean>(props.nonConforme);
  const [finesse, setFinesse] = useState(_defineFinesse(props));
  const [isOpen, setOpen] = useState(false);
  const [isOpenInfos, setOpenInfos] = useState(false);
  const [idBroderie, setIdBroderie] = useState(null);
  const [isValidBroderie, setBroderieValid] = useState<boolean>(false);
  const [fetchBroderie, declencherFetchBroderie] = useState<boolean>(false);
  const [validerBroderie, declencherValidationBroderie] = useState<boolean>(false);
  const [devaliderBroderie, declencherDevalidationBroderie] = useState<boolean>(false);
  const [displayChargementBroderie, setDisplayChargementBroderie] = useState<boolean>(false);
  const [nbCouleursMaxBroderie, setNbCouleursMaxBroderie] = useState<number>(8);
  const [nbCouleursBroderie, setNbCouleursBroderie] = useState<number>(0);
  const [wantReUseFils, setWantReUseFils] = useState<boolean>(false);
  const [numberfils, setNumberfils] = useState<number | null>(null);
  const [controlPreviewActiv, setControlPreviewActiv] = useState<number>(0);
  const [sfcId] = useState<number>(props.surfaceId);
  const [empId] = useState<number>(props.emplacementId);
  const [sfcEmpId] = useState<number>(props.surfaceEmplacementId);

  useEffect(() => {
    if(props.data.originalFileInfos.gfvId && props.data.isBatAutoBroderie) {
      setIdBroderie(props.data.originalFileInfos.gfvId)
    }
  }, []);

  useEffect(() => {
    if(statut != props.statutVisuel) {
      setStatut(props.statutVisuel);
    }
    if(key != props.data.keyVisuel) {
      setKey(props.data.keyVisuel);
    }
    if(finesse != _defineFinesse(props)) {
      setFinesse(_defineFinesse(props));
    }
  }, [props.statutVisuel, props.data]);
  const badQuality = props.data.originalFileInfos.quality.quality == 'bad' ;
  const fusionMultiply = props.fusionMultiply ? 'multiply' : 'unset';
  const needOperator = finesse || badQuality;


  function handleChangeReupload(e: React.ChangeEvent<HTMLInputElement>) {
    setOpen(false);
    props.onReupload(e);
  }

  function setPreviewActiv(id: number = 0, viewed: boolean, clicked: boolean = false) {
    if(clicked) {
      setControlPreviewActiv(id);
    }
  }

  function handleChangeCorrections() {
    setOpen(false);
    setStatut(1);
    props.handleChangeRowValidationVisuelChecked(key, 1);
  }

  function handleValidationBAT(isDevalidation: boolean = false) {
    if(!isDevalidation) {
      setOpen(false);
    }
    let statut = props.data.isInternalUser ? 3 : 2;
    if(isDevalidation) {
      statut = 0;
    }
    setStatut(statut);
    props.handleChangeRowValidationVisuelChecked(key, statut);
  }

  function handleNonConforme(value: boolean) {
    setNonConforme(value);
    props?.handleChangeNonConformeChecked?.(key, value);
  }

  function handleDisplayChargement(display: boolean) {
    setDisplayChargementBroderie(display);
  }

  function handleCanReUseFils(wantReUseFil: boolean) {
    setWantReUseFils(wantReUseFil);
  }


  function handleChangeConformity(etat: boolean) {
    if(!etat) {
      declencherDevalidationBroderie(true);
    }
    props.handleChangeConformity(etat);
  }

  function setBroderieValidAndStatutVisuel(isValidBroderie: boolean) {
    setBroderieValid(isValidBroderie);
    if(!isValidBroderie) {
      const value = (props.data.isInternalUser || !isBatAutoBroderieCustomerCanChoiceBroderie) ? 1 : 0;
      setStatut(value);
      props.handleChangeRowValidationVisuelChecked(key, value);
    } else {
      const value = (props.data.isInternalUser) ? 3 : 2;
      if(props.statutVisuel !== value && props.statutVisuel !== 2) {
        setStatut(value);
        props.handleChangeRowValidationVisuelChecked(key, value);
        setOpen(false);
      }
    }
  }

  function fetchFilsBroderie(nbFils: number | null = null) {
    if(nbFils) {
      setNumberfils(nbFils);
    }
    declencherFetchBroderie(!fetchBroderie);
  }

  function validerFilsBroderie() {
    declencherValidationBroderie(!validerBroderie);
  }

  function devaliderFilsBroderie() {
    declencherDevalidationBroderie(!devaliderBroderie);
  }

  const renderMoreInfo = () => {
   return (
     <div className={'text-center'}>
       <button className="btn grey border d-flex align-items-center font12 mt-5 mx-auto " onClick={() => { setOpenInfos(!isOpenInfos)}}>En savoir plus sur mon BAT</button>
       <p className={`grey border encartNotesBat text-left font12 align-self-start mt-4 p-4  ${isOpenInfos ? '' : 'd-none'} `}>
       <span className="bold">Plus d'informations sur mon BAT :</span>
    <ul>
      <li>Les visuels fournis sont redimensionnés et placés automatiquement selon les caractéristiques de
        votre commande.
      </li>
      <li>L'emplacement et la dimension de vos visuels ne peuvent pas être modifiés.</li>
      <li>Les pictogrammes représentant les articles sont non contractuels.</li>
      <li>Les couleurs du BAT sont des couleurs écran données à titre indicatif, elles ne peuvent refléter les
        couleurs sur le textile marqué.
      </li>
    </ul>
       </p>
       </div>
   );
  }

  const renderModal = () => {
    //const isNotTextile = props.data && props.data.pictogramme && props.data.pictogramme.nom && props.data.pictogramme.nom === "stylo";
    const opacityBg = finesse ? 1 : 1;
    const opacityFibres = finesse ? 0 : 0.9;
    const styleFibreTextile = bgLikeTextile(props.bgColor, opacityBg, 6, opacityFibres );
    const needBroderie = props.data.isBatAutoBroderie && props.data.marquage.id == 4 && ((props.data.isInternalUser && !props.data.customerView) || isBatAutoBroderieCustomerCanChoiceBroderie || props.data.fromGallery == "1");
    const border = parseInt(props.data.marquage.id,10) === 4 ? "1px solid rgb(222, 226, 230)" : "none";
    const showImgFinesse = finesse && !badQuality && props.data.pathLoadFinesse;
    const showImgControls = !needBroderie && !showImgFinesse && props.data.isInternalUser && !props.data.customerView;
    const canSetStatutline = (props.data.order.StatutCommande == '5' || props.data.order.StatutCommande == '6') && props.data.isInternalUserAdmin && !props.data.customerView;
    let containerStyle = {};
    const isDT = getShopRefInStorage() === 'DT';
    if(controlPreviewActiv === 0 && !isDT) {
      containerStyle = styleFibreTextile;
    } else if(controlPreviewActiv === 3 &&  !isDT) {
      containerStyle = {backgroundColor: props.bgColor}
    }
    return (
        <Modal open={isOpen} onClose={() => {setOpen(!isOpen)}} center classNames={{overlay: 'bootstrap-container', modal: finesse ? 'batModalContainer batModalContainerWithFinesse ' : 'batModalContainer',  closeButton: 'batModalCloseButton closeButton'}}>
          <div  className={'d-flex justify-content-around flex-column flex-md-row '}>
            {!finesse &&
              <div className={`align-self-center   position-relative`} style={{border: border}}>
                {parseInt(props.data.marquage.id,10) === 4 && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
                  <span>Maquette de positionnement</span></div>}
                <img className={parseInt(props.data.marquage.id,10) === 4 ? "pa1" : ""} src={props.data.pathLoadPreview} style={{backgroundColor: props.bgColor}}/>
                {parseInt(props.data.marquage.id,10) === 4 && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
                  <span>Maquette de positionnement</span></div>}
              </div>
            }
            <div className={`align-self-center d-flex  flex-column ml-lg-4 flex-grow-1`} >
              <div className={`position-relative  ${finesse && !needBroderie ? ' bg-alpha-bat-auto-opac50 display-finesse-modale ' : ''} `} >
            <div className={`align-self-center d-flex  flex-column  flex-grow-1`} >
              {needBroderie  &&
                <div className={`${validerBroderie ||  idBroderie ? '' : 'd-none'}`} >
                <Embrodery
                  numberfils={numberfils} pathBatOriginal={props.data.pathBatOriginal}
                  galerieFichierVariableId={props.data.originalFileInfos.gfvId}
                  wantReUseFils={wantReUseFils}
                  idCommande={props.data.order.idCommande} bgColor={props.bgColor} handleDisplayChargement={handleDisplayChargement}
                  reuploadBtnAdminBatValide={props.reuploadBtnAdminBatValide}
                  declencherFetchBroderie={fetchBroderie} declencherValidationBroderie={validerBroderie}
                  declencherDevalidationBroderie={devaliderBroderie} numCommande={props.data.order.numCommande}
                  surfaceId={sfcId} customerChoice={isBatAutoBroderieCustomerCanChoiceBroderie}
                  emplacementId={empId} fileRegisteredId={props.data.fileRegisteredId}
                  validationBat={props.data.validationBat == '2'}
                  dimensions ={props.data.dimensions}
                  isInternalUserAdminNotCustomerView={props.data.isInternalUserAdmin && !props.data.customerView}
                  isInternalUserNotCustomerView={props.data.isInternalUser && !props.data.customerView}
                  setBroderieId={(idBroderie: SetStateAction<any>) => {
                    setIdBroderie(idBroderie)
                  }} setBroderieValide={(isValidBroderie: boolean) => {
                  setBroderieValidAndStatutVisuel(isValidBroderie)
                }}
                  fileRegisteredCreationId={props.data.fileRegisteredCreationId}
                  surfaceEmplacementId={sfcEmpId ?? props.surfaceEmplacementId} caddies={props.data.paniers}
                  defineNbCouleursMax={(nbCouleursMax: number, nbCouleurs: number) => {
                    setNbCouleursMaxBroderie(nbCouleursMax);
                    setNbCouleursBroderie(nbCouleurs);
                  }}
                  getPreview={props.getPreview}
                  traitementContour={props.data.originalFileInfos.outlineProcessing}
                />
                </div>
              }
              <div className={`position-relative ${(props.data.marquage.id == 4  && validerBroderie) || (props.data.marquage.id == 4  && idBroderie) ? 'd-none' : ''}  ${finesse ? ' bg-alpha-bat-auto-opac50 ' : ''} ${controlPreviewActiv === 1 && props.data.isInternalUser && !props.data.customerView ? ' bg-alpha-bat-auto-opac50 showImgControlZoom ' : ''} ${controlPreviewActiv === 2 && props.data.isInternalUser && !props.data.customerView ? ' showImgWhiteToBlack ' : ''}  ${controlPreviewActiv === 3 && props.data.isInternalUser && !props.data.customerView ? ' showImgDilatation ' : ''} ${controlPreviewActiv === 0 ? ' showImgforCustomer ' : ' '}`}  style={containerStyle}>
                  <div className={'d-flex align-items-center justify-content-center  p-3 p-lg-5'}>
                    <div className={`position-relative `}>
                      {showImgFinesse ? (
                        <>
                        <img className='finesse-img-bg imgMainBat' src={props.data.pathLoadBat}  style={emulateCouleurTextile(props.bgColor, props.data.originalFileInfos.outlineProcessing, {mixBlendMode: fusionMultiply})} />
                         <img className="finesse-img" src={props.data.pathLoadFinesse}/>
                        </>
                      ) : (
                        <>
                        {props.data.pathLoadDilatation &&
                            <ZoomImg imgSrc={props.data.pathLoadDilatation}  classImg={`imgWhiteToBlack`}  hiddenImg={controlPreviewActiv !== 3} styleImg={emulateCouleurTextile(props.bgColor, props.data.originalFileInfos.outlineProcessing, {mixBlendMode: fusionMultiply})}/>
                        }
                        <ZoomImg imgSrc={props.data.pathLoadBat} classImg={`${controlPreviewActiv === 2 ? ' imgWhiteToBlack ' : ' finesse-img-bg imgMainBat '}`}  hiddenImg={controlPreviewActiv === 3}   styleImg={emulateCouleurTextile(props.bgColor, props.data.originalFileInfos.outlineProcessing, {mixBlendMode: fusionMultiply})} />
                        </>
                        )
                      }
                    </div>
                  </div>
              </div>
              <div className={'d-flex justify-content-center align-items-center bg-white'}>
                {props.data && props.data.dimensions && !needBroderie &&
                  <div className={`bg-white black text-center py-1 `}>
                    <span className="px-1">{props.data.dimensions.largeur}cm x {props.data.dimensions.hauteur}cm</span>
                  </div>
                }
              {(finesse && !badQuality && props.data.pathLoadFinesse && props.data.isInternalUser && !props.data.customerView) &&
                <a href={`${props.data.pathLoadFinesse}`} title="Télécharger l'image avec la détection des problèmes de finesse" className={'ml-4 black'} download={`${props.data.order.numCommande}-${props.data.identifier}-finesse.png`}>
                  <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger
                </a>
              }
              </div>
              {showImgControls &&
                <ThumbnailsControl handleClickControlImage={setPreviewActiv} controlPreviewActiv={controlPreviewActiv} marquageId={props.data.marquage.id} outlineProcessing={props.data.originalFileInfos.outlineProcessing} isInternalUser={props.data.isInternalUser && !props.data.customerView} bgColor={props.bgColor} styleFibreTextile={styleFibreTextile} pathLoadBat={props.data.pathLoadBat} pathLoadDilatation={props.data.pathLoadDilatation}   />
              }
            </div>
          </div>
            </div>
          </div>
          <div className={"batModalContainerRecap p-1 py-lg-5"}>
            {needOperator && finesse &&
            <div className={' font22 alert alert-warning text-center  mb-4 py-lg-2'}>
              <div>
                <ul className={'list-unstyled ma0 py-2'}>
                  {finesse && !badQuality &&
                  <li className={'red d-flex align-items-center justify-content-center'}>
                    <Icons icon="warning" size={25} color="red" className="mr-2"/> Les éléments entourés en rouge sont considérés comme trop fins par notre système</li>
                  }
                  {badQuality &&
                  <li className={'red d-flex align-items-center justify-content-center'}> <Icons icon="warning" size={25} color="red" className="mr-2"/>  Le fichier est considéré comme étant de mauvaise qualité par notre système.</li>
                  }
                </ul>
              </div>
            </div>
            }
            {(!isBatAutoBroderieNotInternal || isBatAutoBroderieCustomerCanChoiceBroderie) && (props.data.validationBat == '0' || props.reuploadBtnAdminBatValide || canSetStatutline) && ((props.data.order.confirmationFichier == '0') || (props.data.order.confirmationFichier == '1' && statut !== 2)) && getShopInfosInStorage().Ref !== 'DT' &&
              <>
                <div className={'d-flex justify-content-between align-items-center mb-4 grey'}>
                  <div className={'border-top flex-grow-1'}/>
                  <div className={'mx-3'}>Quelles {needOperator ? 'solutions' : 'possibilités '} s'offrent à moi ?</div>
                  <div className={'border-top flex-grow-1'}/>
                </div>
            <div className={`container-operateur-correction ${!needOperator ? 'flex-column-reverse d-flex' : ''}`}>
              {(statut < 1) && <div className={` row ${!needOperator ? ' mt-4' : ' mb-4 '}`}>
                  <BtnActionOperateurCorrection  disabled={(props.data.isInternalUser && props.data.order.confirmationFichier =='1') || badQuality} needCorrectionsChange={handleChangeCorrections}  />
                  <BtnActionReupload authorizedFiles={props.authorizedFiles} reuploadChange={handleChangeReupload} />
                  <BtnActionApplyOutline  disabled={badQuality}  colorMain={props.bgColor} contourCustom={props.data.contourCustom} displayFinesse={finesse} applyOutlineChange={props.handleChangeApplyOutline}   />
                </div>}
              {props.data.isInternalUser && props.data.order.confirmationFichier =='1' && (finesse || (!finesse && props.data.dataConformity  && props.data.dataConformity.etatConformity !== null && props.data.isInternalUser  && !props.data.customerView) && props.data.originalFileInfos) &&
                <div className={`mt-4`}>
                <SwitchActionConformity  data={props.data.dataConformity} canDeclareDestructure={props.data.originalFileInfos.canDeclareDestructure} finesseDetails={props.data.originalFileInfos.finesse}  isInternalUserAdmin={props.data.isInternalUserAdmin && !props.data.customerView } disabled={!props.data.canUpdateFichierDestructure} isBroderie={parseInt(props.data.marquage.id, 10) === 4} handleChangeConformity={handleChangeConformity}/>
              </div>
              }
              {(props.data.isBatAutoBroderie && props.data.marquage.id == 4 && (!finesse || (props.data.dataConformity && props.data.dataConformity.etatConformity !== null && props.data.isInternalUser  && !props.data.customerView))) ?
                <>
                  {(nbCouleursBroderie > nbCouleursMaxBroderie) && idBroderie ?
                    <div className={`alert alert-warning text-center`}>
                      <span>Nous n'autorisons les visuels de broderie que de {nbCouleursMaxBroderie} couleurs maximum. Veuillez adapter votre visuel.</span>
                    </div> :
                    <div className={` ${!needOperator ? ' mt-0' : ' mt-4 '}`}>
                      <BtnActionEmbroidery idCaddies={props.data.paniers[0].idCaddies} displayChargementBroderie={displayChargementBroderie} needSetFilsBroderie={needBroderie && !isValidBroderie}
                        customerView={props.data.customerView}  isValidBroderie={isValidBroderie} idBroderie={idBroderie} wantReUseFil={handleCanReUseFils} fetchFilsBroderie={fetchFilsBroderie}
                        validerFilsBroderie={validerFilsBroderie} devaliderFilsBroderie={devaliderFilsBroderie}  idCommande={props.data.order.idCommande}  numCommande={props.data.order.numCommande}
                        surfaceId={sfcId} emplacementId={empId} fileRegisteredId={props.data.fileRegisteredId} fileRegisteredCreationId={props.data.fileRegisteredCreationId}
                        surfaceEmplacementId={sfcEmpId ?? props.surfaceEmplacementId} traitementContours={props.data.originalFileInfos.outlineProcessing} galerieFichierVariableId={props.data.originalFileInfos.gfvId}
                      />
                    </div>
                  }
                </>:
               <></>
              }
              {(props.data.marquage.id != 4) &&
                <div className={` ${!needOperator ? ' mt-0' : ' mt-4 '}`}>
                  <BtnActionValidationBat disabled={displayChargementBroderie} statut={statut} needOperator={needOperator} isInternalUser={props.data.isInternalUser} customerView={props.data.customerView}  validationBat={handleValidationBAT}  dataConformity={props.data.dataConformity} fichiersConfirmes={parseInt(props.data.order.confirmationFichier,10) === 1} />
                </div>
              }
            </div>
              </>
            }
          </div>
            {getShopInfosInStorage().Ref !== 'DT' && renderMoreInfo()}
        </Modal>
    )
    };

  const renderStateStatut = () => {
    let message = statut && (statut === 2 || statut === 3) ? 'BAT validé' : 'Demande de traitement \u000A par un opérateur';
    let openCondition = true;

    if(!isBatAutoBroderieCustomerCanChoiceBroderie && props.data.isBatAutoBroderie && props.data.marquage.id == 4 && (!props.data.isInternalUser || (props.data.isInternalUser && props.data.customerView))) {
      openCondition = false;
    }

    if(statut && statut === 3 && props.data.isInternalUser &&  !props.data.customerView) {
      message = 'Prêt selon l\'opérateur';
    }
    if( props.data.isBatAutoBroderie && props.data.marquage.id == 4 && statut < 2 && !isBatAutoBroderieCustomerCanChoiceBroderie) {
      message = 'Une adaptation pour la Broderie \u000A sera réalisée par un opérateur'
    } else if(isBatAutoBroderieCustomerCanChoiceBroderie && (statut <= 0) && props.data.isBatAutoBroderie && props.data.marquage.id == 4) {
      message = 'En attente de ma validation';
    }
    if(statut && (statut === 1 ||  statut === 2 ||  statut === 3) && message != '') {
      return (
        <div className={`d-flex italic align-items-center ${statut === 1 ? '' : ''}`} onClick={() => { setOpen(openCondition) }}>
          <Icons icon={`${statut === 1 ? 'verified' : 'verified'}`} style={{alignSelf: 'baseline'}} size={`${statut === 1 ? 20 : 20}`} className={`${statut === 1 && (props.data.isInternalUser || isBatAutoBroderieCustomerCanChoiceBroderie) ? 'orange' : 'green'} mr-1`}/>
          <span style={{whiteSpace: 'pre-line'}}>{message}</span>
        </div>
      );
    } else  {
      message = ((statut && statut === 0) || statut === null) && props.data.isInternalUser &&  !props.data.customerView ? 'En attente de l\'opérateur ' : 'En attente de ma validation';
      return (
        <div className={'italic'}>
          <Icons icon={`wait`} size={20} className={"orange mr-1"}/> {message}
        </div>
      );
    }
  };
  return (
      <div className={'validationBatAutoModaleContainer'}>
        { props.data.order.confirmationFichier == '0' && nonConforme ?
          <NonConforme marquage={parseInt(props.data.marquage.id,10)} /> :<>
        {renderStateStatut()}
        { props.data.isBatAutoBroderie && props.data.marquage.id == 4 ? (
        <div className={"btnImport"}>
          {(props.data.isInternalUser  && !props.data.customerView) &&
              <div className="hiddenFunctionsWrapper">
                {idBroderie ? <div className={"p-2"}>
                  <span>Broderie n°{idBroderie}</span>
                  <span>
                    {isValidBroderie ? <Icons icon={'verified'} style={{alignSelf: 'baseline'}} size={20} className={"green ml-1"}/>
                    : <Icons icon={'wait'} style={{alignSelf: 'baseline'}} size={20} className={"orange ml-1"}/>}
                  </span>
                </div> :
                <div className={"p-2 italic"}>
                  Broderie à vérifier <Icons icon={'wait'} style={{alignSelf: 'baseline'}} size={18} className={"orange ml-1"}/>
                </div>}
                <div className="p-2">
                  <button className={'mt-0 black border-0 py-2 px-3 cursor-pointer m-0  importButton w-100 hiddenFunctionsWrapper'}  onClick={() => { setOpen(true) }}>
                    <Icons icon="visibility" size={20} color="#000" className="mr-2" />
                    Contrôler le fichier
                  </button>
                </div>
                {props.data.order.confirmationFichier == '1' && parseInt(props.data.order.validation_bat,10) < 2 && props.data.isInternalUser &&
                  <div>
                    <CheckboxActionNonConforme nonConforme={nonConforme} onChangeNonConforme={handleNonConforme}/>
                  </div>
                }
              </div>}
          {(isBatAutoBroderieCustomerCanChoiceBroderie && (!props.data.isInternalUser || props.data.customerView))  &&
              <button className={'mt-2 white border-0 py-2 px-3 cursor-pointer m-0 importButton w-100 '}  style={{ background: getBoutiqueColor() }} onClick={() => { setOpen(true) }}>
                <Icons icon="visibility" size={20} color="#fff" className="mr-2" />
                Voir mon BAT
              </button>
            }
        </div>
        ) : (
          <>
            <div className={"btnImport"}>
              {statut === 1 || statut === 2 || statut === 3 ? (
                <button className={'mt-2 black border-0 py-2 px-3 cursor-pointer m-0  importButton w-100'}  id={"voirBat"} onClick={() => { setOpen(true) }}>
                  <Icons icon="visibility" size={20} color="#000" className="mr-2" />
                  Revoir mon BAT
                </button>
              ) : (
                <button className={'mt-2 white border-0 shadow  py-2 px-3 cursor-pointer m-0 importButton w-100 '} id={"voirBat"} style={{ background: getBoutiqueColor() }} onClick={() => { setOpen(true)}}>
                  <Icons icon="visibility" size={20} color="#fff" className="mr-2" />
                  Voir et valider mon BAT
                </button>
              )}
            </div>
            {props.data.order.confirmationFichier == '1' && parseInt(props.data.order.validation_bat,10) < 2 && props.data.isInternalUser &&
              <div className={`row`}>
                <CheckboxActionNonConforme nonConforme={nonConforme} onChangeNonConforme={handleNonConforme}/>
              </div>
            }
          </>
        )}
        {renderModal()}
          </>}
      </div>
  );
}
